module.exports = __webpack_public_path__ + "images/quotas/more-lead-forms-cta.png";